import { RouteConfig } from 'vue-router'
import MainOrders from './main-views/Orders.vue'
import MainInquiries from './main-views/Inquiries.vue'
import UserProfile from './views/UserProfile.vue'
import Customer from './views/Customer.vue'
import Dashboard from './components/orders/dashboard.vue'
import OrderList from './components/orders/order-list.vue'
import NewOrder from './components/orders/new-order/index.vue'
import OrderSummary from './views/OrderSummary.vue'
import Authentication from './views/Authentication.vue'
import LoginComponent from './components/authentication/login.vue'
import LoginCode from './components/authentication/login-code.vue'
import SignupComponent from './components/authentication/signup.vue'
import ForgotPassword from './components/authentication/forgot-password.vue'
import ResetPassword from './components/authentication/reset-password.vue'
import PendingApproval from './components/authentication/pending-approval.vue'
import InquiryList from './components/inquiries/inquiry-list.vue'
import NewInquiry from './components/inquiries/new-inquiry/index.vue'
import InquirySummary from './views/InquirySummary.vue'
import CustomersList from './components/customers/customers-list.vue'
import MainCustomerService from './main-views/CustomerService.vue'
import { getRoutes as getProductSearchRoutes } from './routes/product-search'
import MainProductSearch from './main-views/ProductSearch.vue'
import SalesRep from './views/SalesRep.vue'
import MainExport from './main-views/Export.vue'
import ModelExport from './components/export/model-export.vue'

import { Store } from 'vuex'

import State from './store/types'
import SecurityState, { ResourceType } from './store/security/types'
import { isCustomerSite, isSalesRepSite } from './helpers/sites.helper'

export function getRoutes(): RouteConfig[] {
  const productSearchRoutes = getProductSearchRoutes()
  const redirects =
    process.env.VUE_APP_TPI_ROLE === 'orders' && isCustomerSite(process.env.VUE_APP_TPI_ROLE)
      ? [
          {
            // TODO: rename from topology to edit?
            name: 'homepage-request-override',
            path: '',
            component: MainOrders,
            meta: { title: 'Sales Rep Portal' },
            redirect: { name: 'orderlist' },
          },
        ]
      : []

  return [
    // TODO: this is only needed in this ROLE - don't do in dev role!
    ...redirects,
    {
      path: '/catalog',
      component: MainProductSearch,
      children: [
        ...productSearchRoutes,
      ],
    },
    {
      // TODO: rename from topology to edit?
      path: '/',
      component: MainOrders,
      meta: { title: 'TPI Orders' },
      children: [
        {
          path: '',
          name: 'home',
          components: {
            'main': Dashboard,
          },
          meta: { title: 'Dashboard' },
        },
        {
          path: 'orders',
          name: 'orderlist',
          components: {
            'main': OrderList,
          },
          meta: { title: 'Orders' },
        },
        {
          path: 'profile',
          name: 'user-profile',
          components: {
            'main': UserProfile,
          },
          meta: {
            title: 'User',
            allowNoPermissions: true,
          },
          props: true,
        },
        {
          path: 'new/:fromInquiry?',
          components: {
            'main': NewOrder,
          },
          name: 'new-order',
          meta: { title: 'New Order' },
        },
        {
          path: 'order_summary/:invoiceNo',
          name: 'order_summary',
          components: {
            'main': OrderSummary,
          },
          meta: { title: 'Order Summary' },
          props: true,
        },
      ],
    },
    {
      path: '/inquiry',
      component: MainInquiries,
      meta: { title: 'Inquiries' },
      children: [
        {
          path: '',
          name: 'list-inquiry',
          components: {
            'main': InquiryList,
          },
          meta: { title: 'Inquiries' },
        },

        {
          path: 'new/:fromInquiry?',
          components: {
            'main': NewInquiry,
          },
          name: 'new-inquiry',
          meta: { title: 'New Inquiry' },
        },
        {
          path: 'inquiry_summary/:inquiryId',
          name: 'inquiry_summary',
          components: {
            'main': InquirySummary,
          },
          meta: { title: 'Inquiry Summary' },
          props: true,
        },
      ],
    },
    {
      path: '/customer',
      component: MainCustomerService,
      children: [
        {
          path: '',
          name: 'customers',
          components: {
            'main': CustomersList,
          },
          meta: { title: 'Customers' },
        },
        {
          path: ':customerNumber',
          name: 'customer',
          components: {
            'main': Customer,
          },
          meta: { title: 'Customer' },
          props: true,
        },
      ],
    },
    {
      path: '/authentication',
      component: Authentication,
      meta: {
        allowNotAuthenticated: true,
      },
      children: [
        {
          path: 'login/:checkAcceptance?',
          name: 'login',
          components: {
            view: LoginComponent,
          },
        },
        {
          path: 'signup',
          components: {
            view: SignupComponent,
          },
        },
        {
          path: 'adsignup',
          components: {
            view: SignupComponent,
          },
          meta: {
            allowNotAuthenticated: false,
          },
        },
        {
          path: 'login-code',
          components: {
            view: LoginCode,
          },
          meta: {
            allowNotAuthenticated: true,
          },
        },
        {
          path: 'forgot-password',
          components: {
            view: ForgotPassword,
          },
        },
        {
          path: 'reset-password',
          components: {
            view: ResetPassword,
          },
        },
        {
          path: 'pending-approval',
          components: {
            view: PendingApproval,
          },
        },
        {
          path: 'change-password',
          name: 'change-password',
          components: {
            view: ResetPassword,
          },
          props: { change: true },
          meta: {
            allowNotAuthenticated: false,
          },
        },
      ],
    },
    {
      path: '/export',
      component: MainExport,
      children: [
        {
          path: '',
          name: 'export',
          components: {
            'main': ModelExport,
          },
          meta: { title: 'Pricing and Inventory Tool' },
        },
      ],
    },
    {
      path: '/sales-rep/:salesRepNumber',
      component: SalesRep,
      name: 'sales-rep-profile-single',
      meta: { title: 'Sales Rep' },
      props: true,
    },
    {
      path: '/ordersummary/:invoiceNo(.{32,})',
      name: 'public_order_summary',
      component: OrderSummary,
      meta: {
        title: 'Order Summary',
        allowNotAuthenticated: true,
        allowAuthenticated: true,
      },
      props: true,
    },
  ]
}

export function getWaits(store: Store<State>) {
  return [
    async (to: any, from: any, next: any) => {
      const securityState = (store.state as any).security as SecurityState
      const user = securityState.currentUser
      const salesRepPermissions = (user.ResourcePermissions ?? []).filter(
        (item) => item.Type === ResourceType.SalesRep,
      )
      const site = store.state.site

      const customerPermissions = (user.ResourcePermissions ?? []).filter(
        (item) => item.Type === ResourceType.Customer,
      )
      const allowNoPermissions = (to.matched.some((route: any) => route.meta.allowNoPermissions))
      const requiresAuthentication = to.meta.allowNotAuthenticated !== undefined ? !to.meta.allowNotAuthenticated : !(to.matched.some((route: any) => route.meta.allowNotAuthenticated))
      if (!requiresAuthentication || allowNoPermissions || (salesRepPermissions.length > 0 && isSalesRepSite(site.Name)) || (customerPermissions.length > 0 && isCustomerSite(site.Name))) {
        next()
      } else {
        if (!user || !user.BearerToken || user.BearerToken === '') {
          next('/authentication/login')
        } else if (user.Email === '') {
          next('/authentication/adsignup')
        } else {
          next('/profile')
        }
      }
    },
  ]
}
